export const BUSINESS = {
  name: "Tingadya Travels",
  tagline: "Uttarakhand Taxi & Travel",
  phoneIndia: "+91 86300 25933",
  phoneIndiaRaw: "+918630025933",
  phoneIntl: "+420 723 732 812",
  phoneIntlRaw: "+420723732812",
  email: "tingadyatravelssupport@gmail.com",
  instagram: "@Tingadyatravels",
  instagramUrl: "https://www.instagram.com/tingadyatravels",
  vehicle: "Maruti Suzuki Ertiga VXI",
};

export const waLink = (message, intl = false) =>
  `https://wa.me/${intl ? BUSINESS.phoneIntlRaw.slice(1).replace(/\D/g, "") : BUSINESS.phoneIndiaRaw.slice(1).replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

export const telLink = (raw) => `tel:${raw.replace(/\s/g, "")}`;

export const mailLink = (subject = "Taxi Enquiry — Tingadya Travels", body = "") =>
  `mailto:${BUSINESS.email}?subject=${encodeURIComponent(subject)}${body ? `&body=${encodeURIComponent(body)}` : ""}`;
